module.exports = __webpack_public_path__ + "img/wma.a0f0950d.svg";